/*******************************************************************************
TRIGGER THE FILTER RANGE UI
Handles a click on the filter range edit button.
*******************************************************************************/

export default function openRangeEditor(editorID) {
    const $filterRange = $(`#${editorID}`);

    // We get the current width of the filter range so if the editor is more narrow it doesn't jump
    // up to the previous line (in a multiple filter set scenario)
    const rangeWidth = `${$filterRange.outerWidth()}px`;

    $filterRange.css('min-width', rangeWidth).addClass('is-open').parents('.filter-links-set');
}
